function getDateOf(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
var Clock = /** @class */ (function () {
    function Clock() {
        var _this = this;
        this.nowMinute = null;
        this.today = null;
        this.clockTestOffset = 0;
        this.today = getDateOf(new Date());
        this.update();
        if (location.href.match(/[&?]clocktest/)) {
            setInterval(function () { return _this.clockTestUpdate(); }, 200);
        }
        else {
            setInterval(function () { return _this.update(); }, 1000);
        }
    }
    Clock.prototype.update = function () {
        var now = new Date(), nowMinute = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), 0), today = getDateOf(nowMinute);
        if (!this.nowMinute || nowMinute.getTime() != this.nowMinute.getTime())
            this.nowMinute = nowMinute;
        if (!this.today || today.getTime() != this.today.getTime())
            this.today = today;
    };
    Clock.prototype.clockTestUpdate = function () {
        var testMinute = new Date(this.today);
        testMinute.setHours(8);
        testMinute.setMinutes(this.clockTestOffset);
        this.clockTestOffset = (this.clockTestOffset + 10) % (12 * 60);
        this.nowMinute = testMinute;
    };
    return Clock;
}());
export { Clock };
export var clock = new Clock();
export var HOUR_MS = 60 * 60 * 1000;



//////////////////
// WEBPACK FOOTER
// ./app/ts/clock.ts
// module id = 32
// module chunks = 0